import React, { useEffect, useState } from 'react';
import Image from '../../../components/AppImage';

const HeroSection = () => {
  const heroImages = [
    "/assets/images/hero.jpg",
    "/assets/images/hero.jpeg"
  ];
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveIndex((prev) => (prev + 1) % heroImages.length);
    }, 6000);

    return () => clearInterval(interval);
  }, [heroImages.length]);

  return (
    <section className="relative h-screen min-h-[600px] overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        {heroImages.map((src, index) => (
          <Image
            key={src}
            src={src}
            alt="Estação Marina da Rocha"
            className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-1000 ${
              index === activeIndex ? 'opacity-100' : 'opacity-0'
            }`}
          />
        ))}
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50"></div>
      </div>
      
      {/* Content */}
      <div className="relative z-10 h-full flex items-center justify-center">
        <div className="text-center px-4 -mt-72">
          <h1 className="text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-heading font-bold text-white leading-tight drop-shadow-lg">
            <span className="block">Estação</span>
            <span className="block">O seu ponto de encontro no Altiplano Leste.</span>
          </h1>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;